import { navLinks } from '@/mocks/home';

export default function SiteFooter() {
  return (
    <footer className="w-full bg-secondary-900 py-12 md:py-16">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-8">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-[1.4fr_1fr_1fr] md:gap-8">
          <div>
            <div className="flex items-center gap-3">
              <span className="flex h-10 w-10 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-alarm-warning-line text-xl" />
              </span>
              <div className="flex flex-col leading-none">
                <span className="font-heading text-xl font-black tracking-wide text-background-50">
                  私照外泄
                </span>
                <span className="mt-1 text-[10px] font-medium tracking-[0.28em] text-accent-400">
                  EVENT&nbsp;ARCHIVE
                </span>
              </div>
            </div>
            <p className="mt-5 max-w-md text-sm leading-relaxed text-secondary-200">
              私照外泄事件全程汇总，现场细节、后续进展、内幕争议一网打尽。持续更新最新动态，帮你理清时间线，掌握所有爆料。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base font-bold text-background-50">
              <a href="#top" className="transition-colors hover:text-accent-400">
                内容导航
              </a>
            </h4>
            <ul className="mt-4 flex flex-col gap-3">
              {navLinks.map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    className="text-sm text-secondary-200 transition-colors hover:text-background-50"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-bold text-background-50">
              <a href="#tip" className="transition-colors hover:text-accent-400">
                参与与说明
              </a>
            </h4>
            <ul className="mt-4 flex flex-col gap-3">
              <li>
                <a href="#tip" className="text-sm text-secondary-200 transition-colors hover:text-background-50">
                  爆料入口
                </a>
              </li>
              <li>
                <a href="#inside" className="text-sm text-secondary-200 transition-colors hover:text-background-50">
                  待核实说法清单
                </a>
              </li>
              <li>
                <a href="#ranking" className="text-sm text-secondary-200 transition-colors hover:text-background-50">
                  热度榜单
                </a>
              </li>
              <li>
                <a href="#gallery" className="text-sm text-secondary-200 transition-colors hover:text-background-50">
                  图集线索
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 flex flex-col gap-4 border-t border-secondary-700 pt-7 text-center sm:flex-row sm:items-center sm:justify-between sm:text-left">
          <p className="text-xs text-secondary-300 md:text-sm">
            © 2026 私照外泄 · 本站仅整理公开流传信息，不存放、不传播任何私人内容
          </p>
          <p className="text-xs text-secondary-400 md:text-sm">
            内容以公开可查证信息为准，涉隐私内容一律不予展示
          </p>
        </div>
      </div>
    </footer>
  );
}